<template>
  <div class="invite-rules-root" :class="{ 'ar-style': $i18n.locale === 'ar' }">
    <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
      <van-nav-bar title="" left-arrow @click-left="handleBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.call.tit1') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="rules-content">
      <div class="rules-block" style="letter-spacing: -0.5px">
        <p class="rules-title right-read">{{ $t('lang.commonM.k179') }}</p>
        <p class="rules-row right-read">1. {{ $t('lang.commonM.k180') }}</p>
        <p class="rules-row right-read">2. {{ $t('lang.commonM.k181') }}</p>
        <!-- <p class="rules-row right-read">3. {{ $t('lang.commonM.k182') }}</p> -->
        <MyPLabel class="rules-row right-read" :str="`3. ${$t('lang.commonM.k182')}`" :numsOption="[{ value: limitTime }]" />
        <p class="rules-row right-read">4. {{ $t('lang.commonM.k183') }}</p>
        <p class="rules-row right-read">5. {{ $t('lang.commonM.k184') }}</p>

        <div v-if="baseInfo && baseInfo.userRankRewardDTO" class="zone-block">
          <div class="zone-item right-align">
            <div v-if="baseInfo.userRankRewardDTO.areaDesc === 'Brazil'">{{ $t('lang.commonM.k174') }}</div>
            <div v-else-if="baseInfo.userRankRewardDTO.areaDesc === 'Latin America'">{{ $t('lang.commonM.k175') }}</div>
            <div v-else-if="baseInfo.userRankRewardDTO.areaDesc === 'Middle East'">{{ $t('lang.commonM.k176') }}</div>
            <div v-else-if="baseInfo.userRankRewardDTO.areaDesc === 'Indonesia'">{{ $t('lang.commonM.k177') }}</div>
            <div v-else>{{ $t('lang.commonM.k178') }}</div>
          </div>
        </div>
      </div>

      <div class="rules-block">
        <p class="rules-title right-read">{{ $t('lang.commonM.k170') }}</p>
        <!-- <p class="rules-row right-read">1. {{ $t('lang.commonM.k185') }}</p> -->
        <MyPLabel class="rules-row right-read" :str="`1. ${$t('lang.commonM.k185')}`" :numsOption="[{ value: limitTime }]" />
        <p class="rules-row right-read">2. {{ $t('lang.commonM.k186') }}</p>
        <p class="rules-row right-read">3. {{ $t('lang.commonM.k187') }}</p>
        <p class="rules-row right-read">4. {{ $t('lang.commonM.k188') }}</p>
        <p class="rules-row right-read">5. {{ $t('lang.commonM.k189') }}</p>

        <div v-if="baseInfo" class="list-table">
          <div class="list-fields right-read">
            <div class="field field1">{{ $t('lang.kissGf.ranking') }}</div>
            <div class="field field2">
              {{ $t('lang.mybean.bonus') }}
              <img :src="getMatchImg('beans')" />
            </div>
          </div>
          <div class="list-fields right-read" v-for="(item, index) in baseInfo.rankRewardDTOs" :key="index">
            <div class="bd-field field1">{{ item.range }}</div>
            <div class="bd-field field2">{{ item.rewardCount }}</div>
          </div>
        </div>
      </div>

      <div class="rules-block" style="letter-spacing: -0.5px">
        <p class="rules-title right-read">{{ $t('lang.commonM.k190') }}</p>
        <p class="rules-row right-read">1. {{ $t('lang.commonM.k191') }}</p>
        <p class="rules-row sub-row right-read">
          <span>•</span>
          <span>{{ $t('lang.commonM.k192') }}</span>
        </p>
        <p class="rules-row sub-row right-read">
          <span>•</span>
          <span>{{ $t('lang.commonM.k193') }}</span>
        </p>

        <p class="rules-row right-read">2. {{ $t('lang.commonM.k194') }}</p>
        <p class="rules-row sub-row right-read">
          <span>•</span>
          <span>{{ $t('lang.commonM.k195') }}</span>
        </p>
        <p class="rules-row sub-row right-read">
          <span>•</span>
          <span>{{ $t('lang.commonM.k196') }}</span>
        </p>
        <p class="rules-row sub-row right-read">
          <span>•</span>
          <span>{{ $t('lang.commonM.k197') }}</span>
        </p>

        <p class="rules-row right-read">3. {{ $t('lang.commonM.k198') }}</p>
        <p class="rules-row sub-row right-read">
          <span>•</span>
          <span>{{ $t('lang.commonM.k199') }}</span>
        </p>
        <p class="rules-row sub-row right-read">
          <span>•</span>
          <span>{{ $t('lang.commonM.k200') }}</span>
        </p>
      </div>

      <div class="rules-block" style="letter-spacing: -0.5px">
        <p class="rules-title right-read">{{ $t('lang.commonM.k201') }}</p>
        <p class="rules-row right-read">1. {{ $t('lang.commonM.k202') }}</p>
        <p class="rules-row right-read">2. {{ $t('lang.commonM.k203') }}</p>
        <p class="rules-row right-read">3. {{ $t('lang.commonM.k204') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetHostessRankCfgApi } from '@/api/imee.js'

function formatHM(time) {
  let da = new Date(time)
  let hours = da.getHours().toString().padStart(2, '0')
  let minutes = da.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

export default {
  data() {
    const query = this.$route.query
    return {
      barHeight: query.statusBarHeight || 38,
      baseInfo: null,
      limitTime: ''
    }
  },
  methods: {
    handleBack() {
      this.goPrevious()
    },
    getRules() {
      apiGetHostessRankCfgApi().then((resData) => {
        if (resData) {
          if (resData.rankRewardDTOs && resData.rankRewardDTOs.length) {
            resData.rankRewardDTOs.forEach((item) => {
              if (item.rankStart === item.rankEnd) {
                item.range = `${item.rankStart}`
                return
              }
              if (item.rankStart < item.rankEnd) {
                item.range = `${item.rankStart}-${item.rankEnd}`
              }
            })
          }

          if (resData.userRankRewardDTO && resData.userRankRewardDTO.settleTime) {
            this.limitTime = resData.userRankRewardDTO.settleTime || '18:00'
          }

          this.baseInfo = resData
        }
      })
    }
  },
  created() {
    this.getRules()

    // let uid = this.getUid()
    // window.localStorage.setItem(`cacheRulesTipsShow${uid}`, 'showed')
  }
}
</script>
<style lang="scss" scoped>
.invite-rules-root {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .van-bar-block {
    background: #f9f9fb;
  }

  .rules-content {
    flex: 1;
    width: 100%;
    background-color: #f9f9fb;
    overflow-y: scroll;
  }

  .rules-block {
    background-color: #ffffff;
    padding: 16px 24px;
    margin-bottom: 10px;

    .deliver-line {
      width: 327px;
      height: 1px;
      margin: 0 auto;
      transform: rotateX(45deg);
      background: #ededed;
    }

    .zone-block {
      width: 100%;
      overflow: hidden;
      .zone-item {
        float: left;
        width: 50%;
        margin-bottom: 16px;
        color: #333333;
        font-size: 15px;
        & > div {
          padding: 8px 10px;
          border-radius: 20px;
          // border: 1px solid #b2b2b2;
          display: inline-flex;
          align-items: center;
          // img {
          //   width: 16px;
          //   height: 16px;
          //   border-radius: 50%;
          //   margin-right: 6px;
          // }
        }
      }
    }

    .more-btn {
      min-width: 150px;
      margin: 0 auto;
      padding: 10px 0;
      font-family: RobotoFlex;
      font-weight: 400;
      font-size: 15px;
      color: #a338fc;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 12px;
        height: 13px;
        margin-left: 4px;
        transform: rotateZ(90deg);
      }
      &.expanded {
        img {
          transform: rotateZ(270deg);
        }
      }
    }

    .list-table {
      background-color: #fafafa;
      border-radius: 10px;
      padding: 5px 0;
      .list-fields {
        width: 100%;
        display: flex;
        margin: 14px 0;
        .field {
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 14px;
          color: #b2b2b2;
          text-align: center;
          img {
            width: 14px;
            height: 14px;
            vertical-align: middle;
          }
        }
        .field1 {
          width: 50%;
        }
        .field2 {
          width: 50%;
        }

        .bd-field {
          min-height: 36px;
          font-family: RobotoFlex;
          font-weight: 400;
          font-size: 15px;
          color: #333333;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .rules-title {
    font-family: RobotoFlex;
    font-weight: normal;
    font-size: 17px;
    line-height: 20px;
    color: #333333;
    width: 100%;
    text-align: center;
    font-weight: bolder;
    padding: 16px 0 24px;
  }

  .rules-row {
    font-family: RobotoFlex;
    font-weight: 400;
    font-size: 15px;
    color: #333333;
    line-height: 22px;
    margin-bottom: 12px;
    letter-spacing: -0.5px;

    .beans-img {
      width: 18px;
      height: 18px;
      display: inline-block;
      vertical-align: middle;
    }

    .color-purple {
      color: #a338fc;
    }
  }

  .sub-row {
    padding-left: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    span {
      display: inline-block;
      vertical-align: baseline;
      &:last-child {
        margin-left: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
.invite-rules-root {
  .custom-nav-block {
    background-color: #f9f9fb;
  }
  .van-nav-bar {
    .van-nav-bar__content {
      .van-nav-bar__left {
        .left-nav {
          width: 20px;
          height: 20px;
        }
        .tit-left {
          font-family: RobotoFlex;
          font-weight: normal;
          font-size: 20px;
          color: #333333;
        }
      }
    }
  }
}

.ar-style.invite-rules-root {
  .rules-block {
    .zone-block {
      .zone-item {
        & > div {
          img {
            margin-left: 4px;
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
